import React, { FC } from 'react';
import classnames from 'classnames';
import { Type } from './enums/type.enum';
import { Props } from './props';
import './styles.scss';

export * from './enums/type.enum';

export const Wrapper: FC<Props> = ({ className = null, type = Type.DEFAULT, children }) => {
  const wrapperClassName = classnames(
    'ewc-content-wrapper',
    type !== 'default' && `ewc-content-wrapper--${type}`,
    className,
  );

  return <div className={wrapperClassName}>{children}</div>;
};
